import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { Modal, Form, FormGroup } from 'react-bootstrap';
import * as umoModifications from '../../constants/umoModifications';
import Button from '../ui/Button';
import { createZIPExportURL } from '../../utils/umoUtils';
import { downloadExportFile } from '../../utils/uiUtils';

let photoOptions = [];
let audioOptions = [];
let videoOptions = [];
let docOptions = [];

/** @param {{sfx:string}} piction param */
class ZipDownloadDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      error: null,
      isSuccess: false,
      photoDeriv: 0,
      videoDeriv: 0,
      audioDeriv: 0,
      documentDeriv: 0,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.updateField = this.updateField.bind(this);
    this.getDerivsData = this.getDerivsData.bind(this);
  }

  onFormSubmit(e) {
    e.preventDefault();

    const data = [];
    // each option pushed individually, this is to accommodate for
    // download options that aren't set in the piction Command Center
    if (photoOptions.length > 0) {
      data.push(...[
      { image_type: umoModifications.UMO_TYPE_PHOTO },
      { DERIVATIVE: photoOptions[this.state.photoDeriv].DERIVATIVE },
        { DNUM: photoOptions[this.state.photoDeriv].DNUM },
      ]);
    }
    if (videoOptions.length > 0) {
      data.push(...[
      { image_type: umoModifications.UMO_TYPE_VIDEO },
      { DERIVATIVE: videoOptions[this.state.videoDeriv].DERIVATIVE },
      { DNUM: videoOptions[this.state.videoDeriv].DNUM },
    ]);
    }
    if (audioOptions.length > 0) {
      data.push(...[
      { image_type: umoModifications.UMO_TYPE_AUDIO },
      { DERIVATIVE: audioOptions[this.state.audioDeriv].DERIVATIVE },
      { DNUM: audioOptions[this.state.audioDeriv].DNUM },
    ]);
    }
    if (docOptions.length > 0) {
      data.push(...[
      { image_type: umoModifications.UMO_TYPE_DOCUMENT },
      { DERIVATIVE: docOptions[this.state.documentDeriv].DERIVATIVE },
      { DNUM: docOptions[this.state.documentDeriv].DNUM },
    ]);
    }

    const ZipURL = createZIPExportURL(this.props.umoList,
      `IN_CATEGORY:"${this.props.workspaceID}"`, data, this.props.isSelectAll);

    downloadExportFile(ZipURL, false);
    this.props.addMessage('umoModifyDialog.inProgressMessage');
    this.props.hideUMOModifyDialog();
  }

  getDerivsData() {
    audioOptions = [];
    videoOptions = [];
    photoOptions = [];
    docOptions = [];

    _.map(this.props.downloadOptions, (option) => {
      switch (option.n[0].$.it) {
        case umoModifications.UMO_TYPE_PHOTO:
          photoOptions.push({
            name: option.n[0]._,
            DERIVATIVE: option.n[0].$.rc,
            DNUM: option.n[0].$.sfx,
          });
          break;
        case umoModifications.UMO_TYPE_AUDIO:
          audioOptions.push({
            name: option.n[0]._,
            DERIVATIVE: option.n[0].$.rc,
            DNUM: option.n[0].$.sfx,
          });
          break;
        case umoModifications.UMO_TYPE_VIDEO:
          videoOptions.push({
            name: option.n[0]._,
            DERIVATIVE: option.n[0].$.rc,
            DNUM: option.n[0].$.sfx,
          });
          break;
        case umoModifications.UMO_TYPE_DOCUMENT:
          docOptions.push({
            name: option.n[0]._,
            DERIVATIVE: option.n[0].$.rc,
            DNUM: option.n[0].$.sfx,
          });
          break;
        default:
          break;
      }
    });
  }

  updateField(newData) {
    const fieldsState = {
      embedMeta: this.state.embedMeta,
      photoDeriv: this.state.photoDeriv,
      videoDeriv: this.state.videoDeriv,
      audioDeriv: this.state.audioDeriv,
      documentDeriv: this.state.documentDeriv,
      ...newData,
    };

    this.setState(fieldsState);
  }

  render() {
    const { intl } = this.props;
    this.getDerivsData();

    return (
      <div className="workspace-dialog__form">
        <div className="workspace-dialog__form-header">
          {intl.formatMessage({ id: 'workspaceDownloadDialog.mainTitle' })}
          <div className="workspace-dialog__form-header-sub">
            {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsTitle' })}
          </div>
          <br />
          <div className="workspace-dialog__form-header-text">
            {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsSubTitle' })}
          </div>
        </div>
        <Form onSubmit={this.onFormSubmit}>
          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsPhoto' })}
            </label>
            <select
              name="PHOTO"
              className="form-control"
              value={this.state.photoDeriv.name}
              onChange={(e) => { this.updateField({ photoDeriv: e.target.value }); }}
            >
              {_.map(photoOptions,
                (opt, i) => <option key={opt.name} value={i}>{opt.name}</option>)}
            </select>
          </FormGroup>

          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsVideo' })}
            </label>
            <select
              className="form-control"
              name="VIDEO"
              onChange={(e) => { this.updateField({ videoDeriv: e.target.value }); }}
              value={this.state.videoDeriv}
            >
              {_.map(videoOptions,
                (opt, i) => <option key={opt.name} value={i}>{opt.name}</option>)}
            </select>
          </FormGroup>
          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsAudio' })}
            </label>
            <select
              className="form-control"
              name="AUDIO"
              value={this.state.audioDeriv}
              onChange={(e) => { this.updateField({ audioDeriv: e.target.value }); }}
            >
              {_.map(audioOptions,
                (opt, i) => <option key={opt.name} value={i}>{opt.name}</option>)}
            </select>
          </FormGroup>

          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceDownloadDialog.optionsDocuments' })}
            </label>
            <select
              className="form-control"
              name="DOCUMENT"
              value={this.state.documentDeriv}
              onChange={(e) => { this.updateField({ documentDeriv: e.target.value }); }}
            >
              {_.map(docOptions,
                (opt, i) => <option key={opt.name} value={i}>{opt.name}</option>)}
            </select>
          </FormGroup>
          <Modal.Footer>
            <Button onClick={this.props.onCloseClick}>
              {intl.formatMessage({ id: 'umoModifyDialog.buttonCancel' })}
            </Button>

            <Button primary type="submit">
              {intl.formatMessage({ id: 'umoModifyDialog.buttonApply' })}
            </Button>
          </Modal.Footer>
        </Form>
      </div>
    );
  }
}

ZipDownloadDialog.propTypes = {
  hideUMOModifyDialog: PropTypes.func,
  umoList: PropTypes.instanceOf(Array),
  workspaceID: PropTypes.string,
  addMessage: PropTypes.func,
  onCloseClick: PropTypes.func,
  downloadOptions: PropTypes.instanceOf(Object),
  isSelectAll: PropTypes.bool,
};

export default injectIntl(ZipDownloadDialog);



// WEBPACK FOOTER //
// ./src/js/components/UMOModifyDialog/ZipDownloadDialog.jsx